"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGalleryImageMetadata = void 0;
const typeguard_1 = require("../types/typeguard");
const galleryImageMetadataRuleSet = {
  filename: (0, typeguard_1.optional)(typeguard_1.isString),
  format: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  size: (0, typeguard_1.optional)(typeguard_1.isNumber),
  width: typeguard_1.isNumber,
  height: typeguard_1.isNumber,
  space: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  channels: (0, typeguard_1.optional)(typeguard_1.isNumber),
  depth: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  density: (0, typeguard_1.optional)(typeguard_1.isNumber),
  chromaSubsampling: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  isProgressive: (0, typeguard_1.optional)(typeguard_1.isBool),
  hasProfile: (0, typeguard_1.optional)(typeguard_1.isBool),
  hasAlpha: (0, typeguard_1.optional)(typeguard_1.isBool),
  orientation: (0, typeguard_1.optional)(typeguard_1.isNumber),
  additionalData: (0, typeguard_1.optional)(typeguard_1.isObject)
};
const isGalleryImageMetadata = g => (0, typeguard_1.isType)(g, galleryImageMetadataRuleSet);
exports.isGalleryImageMetadata = isGalleryImageMetadata;